export function mapOptions(unmappedOptions) {
  return Object.values(unmappedOptions).map(o => ({
    label: o.viewValue,
    value: o.serverValue,
  }));
}
